<template>
  <el-form
    ref="enterpriseForm"
    :model="formData"
    :rules="rules"
    label-width="180px"
  >
    <div class="form-section">
      <h3 class="section-title">机构基本信息</h3>
      <div class="form-row">
        <el-form-item label="单位性质" prop="registerInfo.organization">
          <el-select
            v-model="formData.registerInfo.organization"
            placeholder="请选择单位性质"
          >
            <el-option label="行政事业" value="行政事业"></el-option>
            <el-option label="社会组织" value="社会组织"></el-option>
            <el-option label="企业" value="企业"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构名称" prop="registerInfo.companyName">
          <el-input
            v-model="formData.registerInfo.companyName"
            placeholder="请输入机构名称"
          />
        </el-form-item>
      </div>
      <!-- 统一信用代码，证件图片 -->
      <div class="form-row">
        <el-form-item
          label="统一信用代码"
          prop="registerInfo.unifiedCreditCode"
        >
          <el-input
            v-model="formData.registerInfo.unifiedCreditCode"
            placeholder="请输入统一信用代码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="证件图片"
          prop="registerInfo.unifiedCreditCodeImage"
          required
        >
          <el-upload
            :action="uploadUrl"
            accept="image/jpeg,image/png"
            :before-upload="beforeUpload"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="formData.registerInfo.unifiedCreditCodeImage"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传 JPG/PNG 图片，且不超过 2MB
            </div>
          </el-upload>
        </el-form-item>
      </div>
      <!-- 地址，所属区域 -->
      <div class="form-row">
        <el-form-item label="地址" prop="registerInfo.address">
          <el-input
            v-model="formData.registerInfo.address"
            placeholder="地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属区域" prop="registerInfo.region">
          <el-select
            v-model="formData.registerInfo.region"
            placeholder="请选择所属区域"
          >
            <el-option label="‌东区" value="‌东区"></el-option>
            <el-option label="‌西区" value="‌西区"></el-option>
            <el-option label="仁和区" value="仁和区"></el-option>
            <el-option label="米易县" value="米易县"></el-option>
            <el-option label="‌盐边县‌" value="‌盐边县‌"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 联系人，联系电话-->
      <div class="form-row">
        <el-form-item label="联系人" prop="registerInfo.contactName">
          <el-input
            v-model="formData.registerInfo.contactName"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="registerInfo.contactPhone">
          <el-input
            v-model="formData.registerInfo.contactPhone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 当单位性质为行政事业时，需要填写办公电话,邮箱不必填写 -->
      <div
        class="form-row"
        v-if="formData.registerInfo.organization === '行政事业'"
      >
        <el-form-item label="办公电话" prop="registerInfo.officePhone">
          <el-input
            v-model="formData.registerInfo.officePhone"
            placeholder="请输入办公电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="registerInfo.email">
          <el-input
            v-model="formData.registerInfo.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 当单位性质为社会组织时，需要填写业务范围，法定代表人，法定代表人联系电话 -->
      <div
        class="form-row"
        v-if="formData.registerInfo.organization === '社会组织'"
      >
        <el-form-item
          label="法定代表人"
          prop="registerInfo.legalRepresentative"
        >
          <el-input
            v-model="formData.registerInfo.legalRepresentative"
            placeholder="请输入法定代表人"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="代表人联系电话"
          prop="registerInfo.legalRepresentativePhone"
        >
          <el-input
            v-model="formData.registerInfo.legalRepresentativePhone"
            placeholder="请输入法定代表人联系电话"
          ></el-input>
        </el-form-item>
      </div>
      <div
        class="form-row"
        v-if="formData.registerInfo.organization === '社会组织'"
      >
        <el-form-item label="业务范围" prop="registerInfo.businessScope">
          <el-input
            v-model="formData.registerInfo.businessScope"
            placeholder="请输入业务范围"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="registerInfo.email">
          <el-input
            v-model="formData.registerInfo.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 当单位性质为企业时，需要填写法定代表人，法定代表人联系电话 -->
      <div
        class="form-row"
        v-if="formData.registerInfo.organization === '企业'"
      >
        <el-form-item
          label="法定代表人"
          prop="registerInfo.legalRepresentative"
        >
          <el-input
            v-model="formData.registerInfo.legalRepresentative"
            placeholder="请输入法定代表人"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="代表人联系电话"
          prop="registerInfo.legalRepresentativePhone"
        >
          <el-input
            v-model="formData.registerInfo.legalRepresentativePhone"
            placeholder="请输入法定代表人联系电话"
          ></el-input>
        </el-form-item>
      </div>
      <div
        class="form-row"
        v-if="formData.registerInfo.organization === '企业'"
      >
        <el-form-item label="邮箱" prop="registerInfo.email">
          <el-input
            v-model="formData.registerInfo.email"
            placeholder="请输入邮箱"
          ></el-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import { modifyInfo } from "@/api/personal.js";
import { getInfo } from "@/api/api.js";
import { setUserInfo } from "@/utils/auth.js";
import { log } from "three";
export default {
  name: "EnterpriseInfoForm",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        registerInfo: {
          organization: "",
          companyName: "",
          unifiedCreditCode: "",
          unifiedCreditCodeImage: [],
          address: "",
          region: "",
          contactName: "",
          contactPhone: "",
          officePhone: "",
          email: "",
          legalRepresentative: "",
          legalRepresentativePhone: "",
          businessScope: "",
        },
      },
      rules: {
        registerInfo: {
          organization: [
            { required: true, message: "请选择单位性质", trigger: "blur" },
          ],
          companyName: [
            { required: true, message: "请输入机构名称", trigger: "blur" },
          ],
          unifiedCreditCode: [
            { required: true, message: "请输入统一信用代码", trigger: "blur" },
          ],
          unifiedCreditCodeImage: [
            { required: true, message: "请上传证件图片", trigger: "blur" },
          ],
          address: [{ required: true, message: "请输入地址", trigger: "blur" }],
          region: [
            { required: true, message: "请选择所属区域", trigger: "blur" },
          ],
          contactName: [
            { required: true, message: "请输入联系人", trigger: "blur" },
          ],
          contactPhone: [
            { required: true, message: "请输入联系电话", trigger: "blur" },
            {
              validator: (rule, value, callback) => {
                if (!/1[3456789]\d{9}$/.test(value)) {
                  callback(new Error("请输入正确的手机号"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            },
          ],
          officePhone: [
            { required: true, message: "请输入办公电话", trigger: "blur" },
          ],
          email: [
            {
              validator: (rule, value, callback) => {
                // 如果值为空（null、undefined、空字符串或纯空格），则直接通过验证
                if (!value || value.trim() === "") {
                  callback();
                  return;
                }
                // 非空时进行正则校验
                const emailReg =
                  /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                if (!emailReg.test(value)) {
                  callback(new Error("请输入正确的邮箱"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            },
          ],
          legalRepresentative: [
            { required: true, message: "请输入法定代表人", trigger: "blur" },
          ],
          legalRepresentativePhone: [
            {
              required: true,
              message: "请输入法定代表人联系电话",
              trigger: "blur",
            },
          ],
          businessScope: [
            { required: true, message: "请输入业务范围", trigger: "blur" },
          ],
        },
      },
      uploadUrl: "https://huachenglargescreen.planttech.cn/apis/common/upload",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.formData = { ...this.formData, ...newVal };
          console.log(this.formData);
          // 确保图片数组存在
          if (!this.formData.registerInfo.unifiedCreditCodeImage) {
            this.$set(this.formData.registerInfo, "unifiedCreditCodeImage", []);
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    submitForm() {
      this.$refs.enterpriseForm.validate((valid) => {
        if (valid) {
          modifyInfo({
            origin: "h5",
            ...this.formData,
            registerInfoTemp: this.formData.registerInfo,
          })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success("保存成功");
                getInfo().then((userRes) => {
                  if (userRes.data.code === 200) {
                    localStorage.setItem(
                      "userInfo",
                      JSON.stringify(userRes.data.data)
                    );
                  }
                });
              } else {
                this.$message.error(res.data.msg || "保存失败");
              }
            })
            .catch((err) => {
              this.$message.error("保存失败");
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.enterpriseForm.resetFields();
    },
    /* 上传图片的操作 */
    handleUploadSuccess(response, file, fileList) {
      if (response.code === 200 && response.data) {
        file.url = response.data;
        // 修正：操作 registerInfo 下的数组
        this.formData.registerInfo.unifiedCreditCodeImage = fileList.map(
          (f) => ({
            name: f.name,
            url: f.url,
            uid: f.uid,
          })
        );
        // 修正：使用正确的 ref 和字段路径
        this.$refs.enterpriseForm.validateField(
          "registerInfo.unifiedCreditCodeImage"
        );
      } else {
        this.$message.error("上传失败，未获取到图片地址");
      }
    },
    // 删除文件回调
    handleRemove(file, fileList) {
      this.formData.registerInfo.unifiedCreditCodeImage = fileList.map((f) => ({
        name: f.name,
        url: f.url,
        uid: f.uid,
      }));
      this.$refs.enterpriseForm.validateField(
        "registerInfo.unifiedCreditCodeImage"
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning("只能上传 1 个文件，请先移除当前文件");
    },
    // 上传前校验（类型+大小，2M）
    beforeUpload(file) {
      const isValidType =
        file.type === "image/jpeg" || file.type === "image/png";
      const isValidSize = file.size / 1024 / 1024 < 2;
      if (!isValidType) {
        this.$message.error("只能上传 JPG/PNG 格式的图片！");
        return false;
      }
      if (!isValidSize) {
        this.$message.error("图片大小不能超过 2MB！");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.form-section {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;

  .section-title {
    color: #333;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 5px;
    border-bottom: 2px solid #409eff;
  }

  .form-row {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    gap: 20px;

    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      flex: 0 0 calc(50% - 10px);
      min-width: 0;
    }
  }
}

.el-input,
.el-select,
.el-date-picker {
  width: 100%;
}

.operation-button {
  border: none !important;
  background: transparent;
  font-size: 20px;
  padding: 0;
}

.operation-button-delete {
  color: #f56c6c;
}
.el-upload__tip {
  margin-top: -10px;
}
</style>
